interface NavbarProps {
  isFixed: boolean;
}

export default function Navbar({ isFixed }: NavbarProps) {
  return (
    <nav
      className={`w-full z-50 transition-all duration-300 ${
        isFixed
          ? 'fixed top-0 bg-white/95 backdrop-blur-md shadow-sm'
          : 'absolute top-0 bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-2 md:py-4 flex justify-between items-center">
        <div
          className={`text-[10px] md:text-lg tracking-wider transition-colors ${
            isFixed ? 'text-gray-900' : 'text-white'
          }`}
        >
          <span className="font-semibold">BAILA BAILA</span> <span className="font-light opacity-80">MOVE</span>
        </div>
        
        <div className="flex items-center gap-8">
          <a
            href="#contact"
            className={`text-[10px] md:text-base font-light transition-colors cursor-pointer ${
              isFixed ? 'text-gray-700 hover:text-gray-900' : 'text-white/90 hover:text-white'
            }`}
          >
            先行案内
          </a>
        </div>
      </div>
    </nav>
  );
}
